import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ProductBundleForm";
import {cancelCreateProductBundle} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validatePresence} from "../../../lib/Validators";
import {Map} from "immutable";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "sku");
  errors = validatePresence(errors, values, "title");
  return errors.toJS();
}

class CreateProductBundleFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.createProductBundle(values.toJS())
      .then((response) => {
        if (response.data.createProductBundle.errors.length <= 0) {
          this.props.cancelCreateProductBundle();
        } else {
          let errors = createValidationErrors(response.data.createProductBundle.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCreateProductBundle();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        validate={validateForm}
        />
    )
  }

}


const CREATE_PRODUCT_BUNDLE = gql`
  mutation createProductBundle($data: ProductBundleInput!) {
    createProductBundle(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(CREATE_PRODUCT_BUNDLE, {
    props: ({ mutate }) => ({
      createProductBundle: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const CreateProductBundleFormContainerWithData = withProductQuery(CreateProductBundleFormContainer);



export default connect(null, {cancelCreateProductBundle})(CreateProductBundleFormContainerWithData);